// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"57e1c0e8","710":"7d2fb492","787":"6db76cf1"}[chunkId] + ".chunk.js";
};